export default __webpack_public_path__ + "static/media/17.a7b6b9cb.jpg";